export default __webpack_public_path__ + "static/media/PeacockPage2.87cdbf8f.txt";